import type { MouseEvent } from 'react';
import { useConfirmParticipation } from '~/hooks/use-landing-state';

/**
 * Кнопка «Участвую в акции» подтверждает участие на сервере (требование «Подтверждение участия»).
 * Её показывают только до подтверждения: после него блоки кнопку не рисуют.
 */
export function useParticipateCta() {
  const confirm = useConfirmParticipation();
  return {
    href: '#gifts',
    onClick: (e: MouseEvent) => {
      e.preventDefault();
      confirm.mutate();
    },
    pending: confirm.isPending,
  };
}
